import React from 'react';
import PropTypes from 'prop-types';
import PgIcon from './pg-icon';
import PgAvatar from './pg-avatar';

/**
 * A single row inside `PgSidebarBusinessMenu`'s scrollable list — grip
 * handle, avatar (initials-derived from `name`), name/plan, and a check
 * mark when `active`. Pegment equivalent of this app's legacy
 * `BusinessMenuItem` (`app/components/ui/business-menu-item.js`), rebuilt
 * on pegment.css's `.pg-ws-item` row instead of raw Tailwind.
 */
const PgBusinessItem = ({ id, name, plan, active, onClick, className }) => (
    <div
        className={['pg-ws-item', active && 'is-active', className].filter(Boolean).join(' ')}
        onClick={() => onClick?.(id)}
    >
        <span className="pg-ws-grip">
            <PgIcon name="grip-vertical" size={14} />
        </span>
        <PgAvatar name={name} size="xs" shape="circle" />
        <div className="pg-ws-meta">
            <div className={`pg-ws-name${active ? ' is-active' : ''}`}>{name}</div>
            <div className="pg-ws-plan">{plan}</div>
        </div>
        {active && (
            <span className="pg-ws-check">
                <PgIcon name="check" size={16} />
            </span>
        )}
    </div>
);

PgBusinessItem.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    plan: PropTypes.string,
    /** Highlighted state via `.is-active`, plus the trailing check mark. */
    active: PropTypes.bool,
    /** Called with `id` on click. */
    onClick: PropTypes.func,
    className: PropTypes.string,
};

PgBusinessItem.defaultProps = {
    name: '',
    plan: '',
    active: false,
    onClick: undefined,
    className: '',
};

export default PgBusinessItem;
